import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

export default function TokenHandler() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify({
          nome: decoded.nome,
          cognome: decoded.cognome,
          email: decoded.email
        }));
        window.history.replaceState({}, document.title, '/');
      } catch (err) {
        console.error('Errore decoding token M365:', err);
      }
    }
  }, []);
  return null;
}
